import React, { useEffect, useRef, useState } from "react";
import SAMPLE from "../data/sample.json";
import SAMPLE_PDF from "/home/tagrikli/Desktop/Yuki/display_page/src/data/P1_100716044_8cha_1.pdf";

import { Accordion, AccordionDetails, AccordionSummary, Container, Paper, Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, Dialog, Backdrop, IconButton, Switch, AlertColor, Collapse, Tooltip } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CloseIcon from "@mui/icons-material/Close";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

import { Document, Page } from "react-pdf";
import { filename2Path, normalizeHeader } from "../helpers/utils";
import { Stack } from "@mui/system";
import PDFViewer from "./PDFViewer";
import { KeyRounded, Margin } from "@mui/icons-material";
import HeaderFooter from "./HeaderFooter";
import { BASE, DATA_PATH, FTYPE } from "../helpers/consts";
import FieldHelper from "../helpers/FieldHelper";

function processHDU0(hdu0: any) {
    let hdu0_: any = {};

    const included = ["method", "mode", "filename", "trigtime", "trigutc"];

    Object.entries(hdu0).forEach((entry) => {
        const key: string = entry[0];
        const value = entry[1];
        if (included.includes(key.toLowerCase())) {
            if (key === "FILENAME") {
                 
                hdu0_["FILENAME"] = (value as string).split(".")[0];
            } else {
                hdu0_[key] = value;
            }
        }
    });
    

    return hdu0_;
}

interface DisplayEventProps {
    onClose: any;
    event: any;
}

export default function DisplayEvent(props: DisplayEventProps) {
    const { onClose, event } = props;
    
    const [pdfPaths, setPdfPaths] = useState<string[]>([]);
    const [pdfPath, setPdfPath] = useState<string>('');
    const [pdfName, setPdfName] = useState<string>('');
    const [data, setData] = useState<any>(undefined);
    const [pdfIndex, setPdfIndex] = useState(0);
    const [bothExist, setBothExist] = useState(true);
    const [openSig, setOpenSig] = React.useState(false);
    const [openTrig, setOpenTrig] = React.useState(false);
    const [openFil, setOpenFil] = React.useState(false);
    const [deleteFiles, setDeleteFiles] = React.useState(false);
    const refAttr = useRef<string>('')
    const fh = new FieldHelper();
    

    const onPdfChange = (event: any, value: boolean) => {
        value ? 
        setPdfPath(`${BASE}/mysql_utils/file_reader.php?file_name=` + pdfName + '_8cha.pdf') : 
        setPdfPath(`${BASE}/mysql_utils/file_reader.php?file_name=` + pdfName + '_12det.pdf');
    };

    const processDataByEvent = (event: any) => {
        const {method: method, mode: mode} = getMethodModeFromFilename(event.FILENAME)

        const time = new Date(Date.parse(event.TRIGUTC));

        const date = time.toLocaleDateString("en-US", {
            day: "numeric",
            month: "long",
            year: "numeric",
        });

        const hour = time.toLocaleTimeString("en-US", {
            hour: "numeric",
            minute: "numeric",
        });

        const detectorsSTR = event.Detectors;
        const detectorsArray = detectorsSTR.split("").map(Number);

        const probabilitiesArr = createProbabilitiesArray(event);
        const gradesArr = createGradesArray(event);

        // setData({ HDU0: HDU0_, HDU1: HDU1, HDU1_: HDU1_, HDU3: HDU3, time: time, date: date, hour: hour, method: method, mode: mode, sig: sig });
        setData({ event: event, metTime: event.TRIGTIME, utcTime: event.TRIGUTC, method: method, mode: mode, detectors: detectorsArray, probabilitiesArr: probabilitiesArr, gradesArr: gradesArr});
    };

    const createProbabilitiesArray = (event: any) => {
        const result = [];

        result.push([event.SGR_Prob, "SGR"]);
        result.push([event.SGRB_Prob, "SGRB"]);
        result.push([event.LGRB_Prob, "LGRB"]);
        result.push([event.SFL_Prob, "SFL"]);
        result.push([event.TGF_Prob, "TGF"]);
        result.push([event.TRANSNT_Prob, "TRANSNT"]);
        result.push([event.LPAR_Prob, "LPAR"]);
        result.push([event.DPAR_Prob, "DPAR"]);
        result.push([event.NO_EVALUATION, "NO_EVALUATION"]);

        return result;
    }

    const createGradesArray = (event: any) => {
        const result = [];

        result.push([event.TRIG_GR, event.TRIG_ID]);
        result.push([event.SFL_GR, event.SFL_ID]);
        result.push([event.TRANSNT_GR, event.TRANSNT_ID]);
        result.push([event.PAR_GR, "Particle Grade"]);

        return result;
    }

    const getMethodModeFromFilename = (filename:string) => {
        const methods = {
            "B": "Bayesian",
            "P": "Poisson",
            "S": "SNR"
        }

        const modes = {
            "1": "Mode 1",
            "2": "Mode 2",
            "3": "Mode 3",
            "4": "Mode 4",
        }

        let firstChar: string = filename.at(0)!
        let secondChar: string = filename.at(1)!
        let fileMethod = methods[firstChar as keyof typeof methods]
        let fileMode = modes[secondChar as keyof typeof modes]
        return {method: fileMethod, mode: fileMode}
    }

    useEffect(() => {
        if (event !== undefined) {
            setDeleteFiles(false)

            processDataByEvent(event);
            const pdf_paths = filename2Path(event.filename || event.FILENAME, FTYPE.PDF) as string[];
            const filename = event.filename || event.FILENAME;

            fetch(`${BASE}/mysql_utils/file_retriever.php`, {
                method: "POST",
                headers: { "Content-Type": "application/x-www-form-urlencoded" },
                body: "&pdf_paths=" + pdf_paths.join(",") + "&file_name=" + filename,
            })
            .then((result) => result.json()) // DEĞİŞİKLİK 1: text() yerine json()
            .then((data) => { // result yerine data diyelim kafa karışmasın
                
                // DEĞİŞİKLİK 2: Başarılı mı diye kontrol et ve filename'i al
                if (data.success) {
                    setPdfPaths(pdf_paths.map((path) => DATA_PATH + "/" + path));

                    const pdfRandomName = data.filename; // DEĞİŞİKLİK 3: substring yerine direkt objeden al
                    
                    setPdfPath(`${BASE}/mysql_utils/file_reader.php?file_name=` + pdfRandomName + '_12det.pdf')
                    setPdfName(pdfRandomName)
                    
                    // State hemen güncellenmeyeceği için burada local değişkeni kullanmak daha güvenli
                    refAttr.current = pdfRandomName 
                } else {
                    console.error("Dosya alma hatası:", data.error);
                }
            })
            .catch((reason) => {
                console.log("Fetch Hatası:", reason);
            });

            return () => {
                setDeleteFiles(true)
            }
        } else {
    
        }
    }, [ event ]);
    useEffect(() => {
        if (deleteFiles)
            fetch(`${BASE}/mysql_utils/file_delete.php?file_name=` + pdfName, {
                method: "DELETE",
                headers: { "Content-Type": "ax-www-form-urlencoded" },
            })
    }, [deleteFiles])

    return (
        <Dialog open={event !== undefined} onClose={onClose} sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }} fullWidth={true} maxWidth="xl">
            {event === undefined ? (
                <div>No Filename</div>
            ) : data === undefined ? (
                <div>Loading...</div>
            ) : (
                <Box sx={{ width: "100%" }} height="90vh">
                    <Stack margin={0} padding={4} direction="row" justifyContent="space-between" alignItems="center">
                        <Typography fontSize={"x-large"} textAlign="center" margin={0}>
                            {data.method} - {data.mode} event on {data.utcTime} UTC
                        </Typography>
                        <IconButton onClick={() => onClose(undefined, "backdropClick")}>
                            <CloseIcon></CloseIcon>
                        </IconButton>
                    </Stack>

                    <Stack padding={{ md: 5 }} direction={{ md: "row" }} justifyContent="space-between" spacing={{ sm: 1, md: 6 }}>
                        <Box flex={{ md: 1 }}>
                            <TableContainer component={Paper}>
                                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell><strong>Property</strong></TableCell>
                                            <TableCell align="right"><strong>Value</strong></TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        <TableRow
                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                        >
                                            <TableCell component="th" scope="row">
                                                Method
                                            </TableCell>
                                            <TableCell align="right">{data.method}</TableCell>
                                        </TableRow>
                                        <TableRow
                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                        >
                                            <TableCell component="th" scope="row">
                                                Mode
                                            </TableCell>
                                            <TableCell align="right">{data.mode}</TableCell>
                                        </TableRow>
                                        <TableRow
                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                        >
                                            <TableCell component="th" scope="row">
                                                Event Time (MET)
                                            </TableCell>
                                            <TableCell align="right">{data.metTime}</TableCell>
                                        </TableRow>
                                        <TableRow
                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                        >
                                            <TableCell component="th" scope="row">
                                                Event Time (UTC)
                                            </TableCell>
                                            <TableCell align="right">{data.utcTime}</TableCell>
                                        </TableRow>
                                        <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
                                            <TableCell component="th" scope="row">
                                                Classes
                                            </TableCell>
                                            <TableCell align="right">
                                            <IconButton
                                                aria-label="expand row"
                                                size="small"
                                                onClick={() => setOpenSig(!openSig)}
                                            >
                                                {openSig ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                                            </IconButton>
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
                                            <Collapse in={openSig} timeout="auto" unmountOnExit>
                                                <Box sx={{ margin: 1 }}>
                                                <Table size="small" aria-label="purchases">
                                                    <TableHead>
                                                    <TableRow>
                                                        <TableCell>Category</TableCell>
                                                        <TableCell align="right">Probabilty</TableCell>
                                                    </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                    {data.probabilitiesArr.map((significanceArray: any) => (
                                                        <TableRow key={significanceArray[1]}>
                                                        <TableCell component="th" scope="row">
                                                            {significanceArray[1]}
                                                        </TableCell>
                                                        <TableCell align="right">{significanceArray[0]}</TableCell>
                                                        </TableRow>
                                                    ))}
                                                    </TableBody>
                                                </Table>
                                                </Box>
                                            </Collapse>
                                            </TableCell>
                                        </TableRow>
                                        <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
                                            <TableCell component="th" scope="row">
                                                Triggered Detectors
                                            </TableCell>
                                            <TableCell align="right">
                                            <IconButton
                                                aria-label="expand row"
                                                size="small"
                                                onClick={() => setOpenTrig(!openTrig)}
                                            >
                                                {openTrig ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                                            </IconButton>
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
                                            <Collapse in={openTrig} timeout="auto" unmountOnExit>
                                                <Box sx={{ margin: 1 }}>
                                                <Table size="small" aria-label="purchases">
                                                    <TableHead>
                                                    <TableRow>
                                                        <TableCell>Detector Name</TableCell>
                                                        <TableCell align="right">Detection</TableCell>
                                                    </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                    {data.detectors.map((element: number, index: number) => (
                                                        <TableRow key={index}>
                                                        <TableCell component="th" scope="row">
                                                            Detector {index}
                                                        </TableCell>
                                                        <TableCell align="right">{element == 1 ? <strong>True</strong>: 'False'}</TableCell>
                                                        </TableRow>
                                                    ))}
                                                    </TableBody>
                                                </Table>
                                                </Box>
                                            </Collapse>
                                            </TableCell>
                                        </TableRow>
                                        <TableRow
                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                        >
                                            <TableCell component="th" scope="row">
                                                Duration (s)
                                            </TableCell>
                                            <TableCell align="right">{data.event.DURATION}</TableCell>
                                        </TableRow>
                                        <TableRow
                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                        >
                                            <TableCell component="th" scope="row">
                                                <Tooltip title="
                                                Burst Count (Epiv - 2000 keV) / Burst Count (10 - Epiv keV) at the peak of the event">
                                                    <span>
                                                        Hardness Ratio (Epiv=25keV)
                                                    </span>
                                                </Tooltip>
                                            </TableCell>
                                            <TableCell align="right">{data.event.HR_25}</TableCell>
                                        </TableRow>
                                        <TableRow
                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                        >
                                            <TableCell component="th" scope="row">
                                                <Tooltip title="
                                                Burst Count (Epiv - 2000 keV) / Burst Count (10 - Epiv keV) at the peak of the event">
                                                    <span>
                                                        Hardness Ratio (Epiv=50keV)
                                                    </span>
                                                </Tooltip>
                                            </TableCell>
                                            <TableCell align="right">{data.event.HR_50}</TableCell>
                                        </TableRow>
                                        <TableRow
                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                        >
                                            <TableCell component="th" scope="row">
                                                <Tooltip title="
                                                Burst Count (Epiv - 2000 keV) / Burst Count (10 - Epiv keV) at the peak of the event">
                                                    <span>
                                                        Hardness Ratio (Epiv=75keV)
                                                    </span>
                                                </Tooltip>
                                            </TableCell>
                                            <TableCell align="right">{data.event.HR_75}</TableCell>
                                        </TableRow>
                                        <TableRow
                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                        >
                                            <TableCell component="th" scope="row">
                                                <Tooltip title="
                                                Burst Count (Epiv - 2000 keV) / Burst Count (10 - Epiv keV) at the peak of the event">
                                                    <span>
                                                        Hardness Ratio (Epiv=300keV)
                                                    </span>
                                                </Tooltip>
                                            </TableCell>
                                            <TableCell align="right">{data.event.HR_300}</TableCell>
                                        </TableRow>
                                         <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
                                            <TableCell component="th" scope="row">
                                                Filtering Results
                                            </TableCell>
                                            <TableCell align="right">
                                            <IconButton
                                                aria-label="expand row"
                                                size="small"
                                                onClick={() => setOpenFil(!openFil)}
                                            >
                                                {openSig ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                                            </IconButton>
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
                                            <Collapse in={openFil} timeout="auto" unmountOnExit>
                                                <Box sx={{ margin: 1 }}>
                                                <Table size="small" aria-label="purchases">
                                                    <TableHead>
                                                    <TableRow>
                                                        <TableCell>ID</TableCell>
                                                        <TableCell align="right">Grade</TableCell>
                                                    </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                    {data.gradesArr.map((gradesArray: any) => (
                                                        <TableRow key={gradesArray[1]}>
                                                        <TableCell component="th" scope="row">
                                                            {gradesArray[1]}
                                                        </TableCell>
                                                        <TableCell align="right">{gradesArray[0]}</TableCell>
                                                        </TableRow>
                                                    ))}
                                                    </TableBody>
                                                </Table>
                                                </Box>
                                            </Collapse>
                                            </TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Box>
                        <Stack flex={{ md: 4 }} direction="column" justifyContent={"stretch"} minHeight="100vh">
                            {true ? (
                                <Stack direction={"row"} justifyContent="end" alignItems="center">
                                    <Typography>12Det</Typography>
                                    <Switch onChange={onPdfChange}></Switch>
                                    <Typography>8Cha</Typography>
                                </Stack>
                            ) : (
                                <div></div>
                            )}

                            <PDFViewer file={pdfPath}></PDFViewer>
                        </Stack>
                    </Stack>
                </Box>
            )}
        </Dialog>
    );
}
